import { useContext } from 'react'

import { digObject } from '@domain-group/javascript-utils'

import { Button, ModalContext, SidebarModal } from '@domain-group/suit-theme'

import AdChannelCard from './AdChannelCard'

const MODAL_KEY = 'SelectAdChannelModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const SelectAdChannelModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { adAccountGroupId } = modalPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Select" titleSecondLine="Ad Account Type" />

      <SidebarModal.Content>
        <AdChannelCard
          adAccountGroupId={adAccountGroupId}
          adChannel="facebook"
          adAccountType="FacebookAdAccount"
        />

        <AdChannelCard
          adAccountGroupId={adAccountGroupId}
          adChannel="facebook"
          adAccountType="FacebookPage"
          marginTop="large"
        />

        <AdChannelCard
          adAccountGroupId={adAccountGroupId}
          adChannel="google"
          adAccountType="GoogleAdAccount"
          marginTop="large"
        />
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loadingBubbleColor="white"
          onClick={() => closeModal()}
          size="large"
        >
          Close
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <SelectAdChannelModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
